/* @flow */
import * as React from 'react';
import _ from 'lodash';
import { Polygon } from 'common/components/core/map/Polygon';
import ConvexHullMaker from 'common/utils/ConvexHullMaker';
import type { LatLngModelType } from 'common/models/flow/LatLng';

export type PolygonTypeType = 'NORMAL' | 'CONVEX_HULL';
type Props = {
    index: number,
    mapHelper: {
        map: ?any,
        maps: ?any
    },
    color: string,
    strokeWeight: number,
    strokeOpacity: number,
    fillOpacity: number,
    theme: Object,
    tooltip: any,
    onHover: ({
        tooltip: React.Element<any>,
        latLng: Object,
        index: number,
        meta: any
    }) => void,
    onHoverOut: () => void,
    type: PolygonTypeType,
    latLngs: any,
    polygonVertices: Array<LatLngModelType>,
    meta: any,
    zIndex: ?number,
    isHovered?: boolean,
    onSelect: ?(number) => void
};
type State = {
    hovered: boolean
};

class PolygonContainer extends React.PureComponent<Props, State> {
    polygonContainer: React.ElementRef<any>;

    static getMonotoneConvexHullFromLatLngs(latLngs: any) {
        if (_.isArray(latLngs[0])) {
            return latLngs.map(polygon => {
                return ConvexHullMaker.monotoneConvexHullFromLatLngs(polygon);
            });
        }
        return ConvexHullMaker.monotoneConvexHullFromLatLngs(latLngs);
    }

    static defaultProps = {
        type: 'NORMAL',
        fillOpacity: 0.35
    };

    constructor(props: Props) {
        super(props);
        this.state = {
            hovered: false,
            isOpen: false,
            tourPopupLeft: 0,
            tourPopupTop: 0
        };
        this.polygonContainer = React.createRef();
    }

    onHover = (id: string, event: any) => {
        const { tooltip, index, meta } = this.props;
        this.setState(
            {
                hovered: true
            },
            () => {
                this.props.onHover({
                    tooltip,
                    latLng: event.latLng,
                    index,
                    meta
                });
            }
        );
    };

    onMouseOut = () => {
        this.setState({ hovered: false }, () => {
            this.props.onHoverOut();
        });
    };

    onSelect = () => {
        const { index, onSelect } = this.props;
        onSelect && onSelect(index);
    };

    getLatLngsForPolygon() {
        const { type, latLngs, polygonVertices } = this.props;
        if (polygonVertices) {
            return polygonVertices;
        }
        if (type === 'CONVEX_HULL') {
            return PolygonContainer.getMonotoneConvexHullFromLatLngs(latLngs);
        }
        return latLngs;
    }

    render() {
        var {
            tooltip,
            mapHelper,
            color,
            strokeWeight,
            strokeOpacity,
            fillOpacity,
            theme,
            zIndex,
            index,
            isHovered
        } = this.props;
        var { hovered } = this.state;

        const fillOpacityBasedOnHover =
            hovered || isHovered ? 0.5 : fillOpacity;
        return (
            <Polygon
                index={index}
                ref={this.polygonContainer}
                mapHelper={mapHelper}
                latLngs={this.getLatLngsForPolygon()}
                theme={theme}
                strokeWeight={strokeWeight}
                strokeOpacity={strokeOpacity}
                strokeColor={color}
                fillColor={color}
                fillOpacity={fillOpacityBasedOnHover}
                onMouseOverOnPolygon={this.onHover}
                onMouseOutOnPolygon={this.onMouseOut}
                onMouseMoveOnPolygon={this.onHover}
                onMouseClickOnPolygon={this.onSelect}
                tooltip={tooltip}
                zIndex={zIndex}
                isHovered={isHovered}
            />
        );
    }
}

export default PolygonContainer;
